import { render } from "./ReportePorTercero.vue?vue&type=template&id=585a8a48&scoped=true"
import script from "./ReportePorTercero.vue?vue&type=script&lang=js"
export * from "./ReportePorTercero.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./ReportePorTercero.vue?vue&type=style&index=1&id=585a8a48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585a8a48"]])

export default __exports__